import React from 'react';
import Layout from '../../components/Layout/Layout';
import NavBar from '../../components/NavBar/NavBar';
import styles from './NavBarPage.module.css';

const NavBarPage = () => {
  return (
    <div className={styles.navbarPage}>
      <NavBar
        size="Desktop 1440"
        hideBottomSeparator={false}
        tickerTextId={1}
        overrideTickerText=""
      />
      <Layout width="1440px">
        <div className={styles.navbarTestContent}>
        </div>
      </Layout>
    </div>
  );
};

export default NavBarPage;